// "Page x of y", Previous / Next and the page-size select (architecture sprint-05 §6.2).
import { RECORDS_PAGE_SIZES } from '@shared/report-rules';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { NativeSelect } from '@/components/ui/native-select';

interface RecordsPaginationProps {
  page: number;
  pages: number;
  size: number;
  onPage: (page: number) => void;
  onSize: (size: number) => void;
}

export function RecordsPagination({ page, pages, size, onPage, onSize }: RecordsPaginationProps): JSX.Element {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-3">
      <p className="text-sm text-muted-foreground">
        Page {page} of {pages}
      </p>
      <div className="flex gap-2">
        <Button variant="ghost" size="xs" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          Previous
        </Button>
        <Button variant="ghost" size="xs" disabled={page >= pages} onClick={() => onPage(page + 1)}>
          Next
        </Button>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <Label htmlFor="records-size" className="whitespace-nowrap">
          Rows per page
        </Label>
        <NativeSelect id="records-size" className="w-20" value={String(size)} onChange={(e) => onSize(Number(e.target.value))}>
          {RECORDS_PAGE_SIZES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </NativeSelect>
      </div>
    </div>
  );
}
